export default __webpack_public_path__ + "static/media/doc-refresh-ico.b56eb0e6.svg";